// ProductDisplaySection.js
import React, { useState, useEffect } from 'react';
import ProductCard from './ProductCard';
import api from '../utils/api';
import { fetchAfterHero, registerShownProducts } from '../utils/feedRegistry';
import '../StylesComponents/product-display-section.css';

function getProductCount() {
  const w = window.innerWidth;
  if (w <= 768) return 6;
  if (w <= 1100) return 6;
  return 8;
}

function ProductDisplaySection({ currentUser }) {
  const [isLoading, setIsLoading] = useState(true);
  const [stockroomProducts, setStockroomProducts] = useState([]);

  const fetchLiveProducts = async (count, excludeIds = [], serverExclude = []) => {
    try {
      const REFRESH_POOL_DEPTH = 8;
      const randomPage = Math.floor(Math.random() * REFRESH_POOL_DEPTH) + 1;
      const fetchCount = Math.min(count + 12, 48);

      const res = await api.get('/api/products', {
        params: {
          limit: fetchCount,
          page: randomPage,
          feedContext: 'market_feed',
          discountRanges: '10+',
          ...(serverExclude.length > 0 ? { exclude: serverExclude.join(',') } : {}),
        },
      });

      let pool = res.data.products || [];

      if (excludeIds.length > 0) {
        const excludeSet = new Set(excludeIds.map(String));
        const filtered = pool.filter(p => !excludeSet.has(String(p._id || p.id)));
        if (filtered.length >= count) pool = filtered;
      }

      for (let i = pool.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [pool[i], pool[j]] = [pool[j], pool[i]];
      }

      return pool.slice(0, count);
    } catch (e) {
      console.error('Market Feed fetch error:', e);
      return [];
    }
  };

  useEffect(() => {
    const init = async () => {
      setIsLoading(true);
      const items = await fetchAfterHero((exclude) => fetchLiveProducts(getProductCount(), [], exclude));
      registerShownProducts(items);
      setStockroomProducts(items);
      setIsLoading(false);
    };
    init();
  }, []);

  if (!isLoading && stockroomProducts.length === 0) return null;

  return (
    <section className="stockroom-cloud-section">
      <div className="market-feed-inner">
        <div className={`market-feed-grid ${isLoading ? 'market-feed-grid--loading' : ''}`}>
          {isLoading
            ? Array.from({ length: getProductCount() }).map((_, i) => (
                <div key={`skeleton-${i}`} className="market-feed-card market-feed-card--skeleton" aria-hidden="true" />
              ))
            : stockroomProducts.map((product, index) => (
                <div key={product._id || product.id || index} className="market-feed-card">
                  <ProductCard
                    product={product}
                    currentUser={currentUser}
                    theme="dark"
                    feedSection="market_feed"
                    position={index}
                    showRetailer
                  />
                </div>
              ))}
        </div>
      </div>
    </section>
  );
}

export default ProductDisplaySection;
